// extracted by mini-css-extract-plugin
module.exports = {"ModalHeader":"ModalEditPolicyCurfew_ModalHeader__2oPi-","ModalBody":"ModalEditPolicyCurfew_ModalBody__INVD1","ButtonClose":"ModalEditPolicyCurfew_ButtonClose__ke5pY"};